/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Custom_DomainInputs */

const en_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Domain`)
};

const es_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio personalizado`)
};

const fr_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaine personnalisé`)
};

const de_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigene Domain`)
};

const ja_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独自ドメイン`)
};

const zh_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义域名`)
};

const ar_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نطاق مخصص`)
};

const id_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain Kustom`)
};

const it_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio Personalizzato`)
};

const ru_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Собственный домен`)
};

const pt_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domínio Personalizado`)
};

const ko_pricing_feature_custom_domain = /** @type {(inputs: Pricing_Feature_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`맞춤형 도메인`)
};

/**
* | output |
* | --- |
* | "Custom Domain" |
*
* @param {Pricing_Feature_Custom_DomainInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_custom_domain = /** @type {((inputs?: Pricing_Feature_Custom_DomainInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Custom_DomainInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_custom_domain(inputs)
	if (locale === "es") return es_pricing_feature_custom_domain(inputs)
	if (locale === "fr") return fr_pricing_feature_custom_domain(inputs)
	if (locale === "de") return de_pricing_feature_custom_domain(inputs)
	if (locale === "ja") return ja_pricing_feature_custom_domain(inputs)
	if (locale === "zh") return zh_pricing_feature_custom_domain(inputs)
	if (locale === "ar") return ar_pricing_feature_custom_domain(inputs)
	if (locale === "id") return id_pricing_feature_custom_domain(inputs)
	if (locale === "it") return it_pricing_feature_custom_domain(inputs)
	if (locale === "ru") return ru_pricing_feature_custom_domain(inputs)
	if (locale === "pt") return pt_pricing_feature_custom_domain(inputs)
	return ko_pricing_feature_custom_domain(inputs)
});